interface JsonLdProps {
  /** Unique id so multiple JSON-LD blocks on the same page don't dedupe each other. */
  id: string
  /** Either a JS object that will be JSON.stringify'd, or a pre-stringified JSON string. */
  data: object | string
}

/**
 * Inert JSON-LD data island for search engines. Renders as a plain
 * `<script type="application/ld+json">` — browsers don't execute non-JS MIME
 * types, so this is data, not code. Use this anywhere you'd otherwise reach
 * for `next/script` with `application/ld+json` (which trips a Next 16 console
 * warning when the surrounding subtree is a Client Component).
 */
export function JsonLd({ id, data }: JsonLdProps) {
  const html = typeof data === "string" ? data : JSON.stringify(data)
  return (
    <script
      id={id}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
